/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import React from 'react';
import { Dropdown, Tooltip } from '../../core';
import { toSelectValue, objectKeysToSelectFormat, sortByLabel, getBlockedDimensions, getRelatedMetrics } from './utils';
import { updateDimensionsWithDate } from '../DruidQueryBuilder/utils';
import { isFraudDimensionInFilter } from '../../../../main/screens/ScreenAdsFraud/fraudUtils';
import DataLimitWarning from './DataLimitWarning';
import { ANALYTICS_CONTEXT } from '../../../../../../shared/constants/analytics';
import { DimensionClassifier } from '../../../support/Provisioning/Dimensions/DimensionClassifier';
import { DEFAULT_DRUID_FILTERS_LIST } from '../../../../../../shared/constants/defaultDruidDimensions';
import { DruidExplanation } from '../../../../../../shared/types/druidTypes';
import { ContextsService } from '../../../../../../shared/Contexts.service';

type Props = {
  allFilters: Record<string, any>;
  dimensions: Array<string>;
  dimensionsToDisplay: Array<string>;
  customLabelMap?: Record<string, any>;
  maxDimensions: number;
  minDimensions: number;
  updateFraudTypeOnCompareByChange?: () => void;
  updateQuery: (query: Record<string, any>) => void;
  recordLimit?: number;
  context?: string;
  granularity?: string;
  query?: Record<string, any>;
  organic?: boolean;
  explanation?: DruidExplanation;
  draggable?: boolean;
  components?: Record<string, any>;
};

class CompareBy extends React.PureComponent<Props> {
  /**
   *  Updates dimensions data
   *  Sends onChange data to parent
   */
  updateCompareBy = (dimensions: Array<string>) => {
    const { maxDimensions, minDimensions, granularity } = this.props;
    let newDimensions = [...dimensions];

    if (dimensions.length < minDimensions) {
      return;
    }

    if (dimensions.length > maxDimensions) {
      // replace the last dimension with the most recently chosen dimension
      newDimensions = [...dimensions.slice(0, maxDimensions - 1), dimensions[dimensions.length - 1]];
    }

    // add/remove date_range dimension if necessary
    if (granularity) {
      newDimensions = updateDimensionsWithDate(granularity, newDimensions);
    }

    this.props.updateFraudTypeOnCompareByChange && this.props.updateFraudTypeOnCompareByChange();
    this.props.updateQuery({
      dimensions: newDimensions,
    });
  };

  removeDateValueCompareByDimension(values) {
    return values.filter((option) => option?.value !== 'date_range');
  }

  removeDimensionsWhichAreNotProvisioned = (options: {
    value: string;
    label: string;
  }): [
    {
      value: string;
      label: string;
    },
  ] => {
    if (!new DimensionClassifier().isProvisioned('last_attributed_touch_data_tilde_id')) {
      return options.filter((item: { value: string; label: string }) => {
        return item?.value !== 'last_attributed_touch_data_tilde_id';
      });
    }
    return options;
  };

  render() {
    const {
      allFilters,
      dimensions,
      dimensionsToDisplay,
      customLabelMap,
      recordLimit,
      context,
      query,
      explanation,
      components = {},
      draggable,
    } = this.props;
    const options = this.removeDimensionsWhichAreNotProvisioned(
      objectKeysToSelectFormat(R.pick(dimensionsToDisplay || DEFAULT_DRUID_FILTERS_LIST, allFilters), customLabelMap) || []
    );

    const blockedDimensions = [
      ...getBlockedDimensions({ explanation, includePotential: false }),
      ...getBlockedDimensions({ explanation, includePotential: true }),
    ];

    let values = dimensions
      ? dimensions.map((dim) => {
          const fraudDimensionInFilter = isFraudDimensionInFilter(dim, query);
          return toSelectValue(dim, customLabelMap, fraudDimensionInFilter);
        })
      : [];

    if (
      context &&
      (ContextsService.isTimeSeriesContext(context) ||
        [ANALYTICS_CONTEXT.SEO_TABLE, ANALYTICS_CONTEXT.TRUEVIEW_TABLE, ANALYTICS_CONTEXT.OTT_TABLE].includes(context))
    ) {
      values = this.removeDateValueCompareByDimension(values);
    }

    return (
      <div className="h_f-1 h_d-f">
        <span className="h_fw-600 h_mstart-10 h_mt-5 fraud-compare-by-label">Compare by</span>
        <Dropdown
          testid={`compare-by`}
          options={options && sortByLabel(options)}
          value={values}
          onChange={(e) => this.updateCompareBy(e.map((o) => o.value))}
          clearable={false}
          multi={true}
          blockedDimensions={blockedDimensions}
          relatedMetrics={getRelatedMetrics(explanation)}
          optionRenderer={
            components.DimensionOption
              ? (option) => (
                  <components.DimensionOption
                    {...option}
                    options={options}
                    blockedDimensions={blockedDimensions}
                    relatedMetrics={getRelatedMetrics(explanation)}
                  />
                )
              : undefined
          }
          className="h_mstart-10 h_w-100"
          outerClassName={draggable ? '' : 'h_w-50'}
          draggable={draggable}
          components={components}
        />
        <Tooltip body={<DataLimitWarning limit={recordLimit} />} className={'compare-by__tooltip'} />
      </div>
    );
  }
}

export default CompareBy;
